import { connect } from 'react-redux'
import { toggleComments } from '../../../../actions/exam';
import CommentIcon from "./CommentIcon";

const mapStateToProps = (state, ownProps) => {
  return {

  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onToggleComments: () => dispatch(toggleComments())
  };
};

const CommentIconContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CommentIcon);

export default CommentIconContainer
